import { compose, withHandlers, lifecycle } from 'recompose'
import { reduxForm, change } from 'redux-form'
import { connect } from 'react-redux'
import { APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME } from 'constant'
import ServiceSelector from './ServiceSelector'
import validate from './validate'

const withOnSubmit = withHandlers({
  onSubmit: ({
    nextPageClick,
    beforeNavigatingToDateTimeStep
  }) => () => {
    beforeNavigatingToDateTimeStep()
    nextPageClick()
  }
})

const withClearDateTimeLifecycle = lifecycle({
  componentDidMount() {
    const { appointmentFormValueChange } = this.props
    appointmentFormValueChange(APPOINTMENT_FORM_NAME, DATE_TIME_SELECTOR_FIELD_NAME, {})
  }
})

export default compose(
  connect(null, { appointmentFormValueChange: change }),
  withOnSubmit,
  withClearDateTimeLifecycle,
  reduxForm({
    validate,
    form: APPOINTMENT_FORM_NAME,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
  })
)(ServiceSelector)
